export const TIPO_CATALOGO = Object.freeze({
    TIPO_DOCUMENTOS: '001',
	OBJETIVO: '002',
    TIPO_PLANES: '003',
    TIPO_PROGRAMAS: '004',
    TIPO_PREGUNTAS: '005',
	TIPO_RESPUESTAS: '006',
	ETAPA: '007'
});

export const TIPO_PLANES = Object.freeze({
    TIPO_REGULAR: '1',
    TIPO_SUB_REGULAR:'2',
    TIPO_PRUEBA: '3',
    TIPO_EMPRESAS: '4',
});
 
 export const TIPO_CURSO = Object.freeze({
    CURSO: '1',
    EXAMEN: '2', 
});
export const OBJETIVOS = Object.freeze({
    OBJETIVO_1: '001', 
    OBJETIVO_2: '002', 
    OBJETIVO_3: '003', 
    OBJETIVO_4: '004' 
});
export const SCHEDULES_OPTIONS = Object.freeze({
    SOLICITUD_MASIVA: '1',
    SOLICITUD_DIRECTA: '2', 
}); 
export const CLASS_REQUEST = Object.freeze({
    REQUEST_PUBLIC: '1',
    REQUEST_PRIVATE: '2', 
}); 
export const TIPO_PREGUNTAS = Object.freeze({
    PREGUNTA_AUDIO: '1', 
    PREGUNTA_AUTOCOMPLETAR: '2',
    PREGUNTA_DIGITAR: '3',
    PREGUNTA_SELECCION: '4', 
    PREGUNTA_SELECCION_MULTIPLE: '5' 
}); 
export const TIPO_PREGUNTAS_ALTERNATIVAS = Object.freeze({
    ALTERNATIVA_AUDIO: '1', 
    ALTERNATIVA_IMAGEN: '2',
    ALTERNATIVA_TEXTO: '3',
}); 

export const TYPE_SCHEDULED = Object.freeze({
    UNPROGRAMMED : 0,
    MASS_REQUEST:1,
    DIRECT_REQUEST:2,
    SCHEDULED: 3
}); 

export const CANCEL_REQUEST = Object.freeze({
    CHILD: 1,
    CHILD_TEACHER:2,
}); 

export const CONFIRM_REQUEST = Object.freeze({
    ACCEPT: 1,
    SEND:2,
}); 

export const STATUS_SCHEDULE = Object.freeze({
    NOT_YET_SEEN: 1,
    SIGHT : 2,
    ACCEPTED: 3,
    SUBMITTED_PROPOSAL : 4,
    NEW_CONFLICTS: 5
}); 



export const PERCENTAGE = Object.freeze({
    COMPLETED: {
        value : 100,
        color : '#00B14F'
    },
    INTERMEDIATED: {
        value : 75 ,
        color : '#ff7514'
    },
    INCOMPLETED: {
        value : 74 ,
        color : '#cc0000'
    }
    
}); 

export const STATUS = Object.freeze({
    EARRING : "1",
    ACCEPTED : "2",
    REJECTED : "3",
    EDITED : "4"
})

export const STATUS_COLOR = Object.freeze({
    //EARRING : "#00B0F0",
    EARRING : "#FF8244",
    ACCEPTED : "#189549",
    REJECTED : "#3D82C4",
    EDITED : "#FF8244"
})

export const TYPE_PROPOSAL_SEND = Object.freeze({
    STUDENT_PROPOSAL  : {
        CODE : '010',
        VALUE : '1'
    },
    TEACHER_PROPOSAL :{
        CODE : '010',
        VALUE : '2'
    },
})
export const TYPE_SCHEDULE_SEND = Object.freeze({
    EARRING  : {
        CODE : '011',
        VALUE : '1'
    },
    ACCEPTED :{
        CODE : '011',
        VALUE : '2'
    },
    REJECTED :{
        CODE : '011',
        VALUE : '3'
    },
    EDITED :{
        CODE : '011',
        VALUE : '4'
    },
})

export const TYPE_OF_SCHEDULE = Object.freeze({
    SCHEDULE_NOT_AVAILABLE :1,
    SCHEDULE_CLASSES_TEACHER :2,
    SCHEDULE_REQUEST :3,
    COUNTERPROPOSAL_REQUEST_TIMETABLE:4
})

export const PERFILES = Object.freeze({
    ALUMNO :1,
    PROFESOR :2,
})

export const PAYMENT_METHODS = Object.freeze({
    CREDIT_DEBIT_CARD: 1,
    BANK_TRANSFER : 2,
}); 


export const TYPE_SCHEDULE = Object.freeze({
    TEACHER: 1,
    STUDENT : 2,
}); 

export const MESES = Object.freeze({
    EN: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
    ES: ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"]
}); 
export const MESES_LONG = Object.freeze({
    EN: ["January","February","March","April","May","June","July","August","September","October","November","December"],
    ES: ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"]
}); 
export const DIA_SEMANA = Object.freeze({
    EN: ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
    ES: ["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"]
}); 
export const DIA_SEMANA_SHORT = Object.freeze({
    EN:  ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    ES:  ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab']
}); 

export const PAGINACIONES = Object.freeze({
    NOTIFICATIONS: 6, 
}); 


export const TYPE_NOTIFICATIONS = Object.freeze({
    PSC_01  : {
        VALUE : '1',
        NAME : 'PSC-01'
    },
    PSC_02 :{
        VALUE : '2',
        NAME : 'PSC-02'
    },
    PSC_05 :{
        VALUE : '5',
        NAME : 'PSC-05'
    },
    PSC_06 :{
        VALUE : '33',
        NAME : 'PSC-06'
    },
    PEH_01 :{
        VALUE : '6',
        NAME : 'PEH-01'
    },
    ESC_01 :{
        VALUE : '9',
        NAME : 'ESC-01'
    },
    ESC_03 :{
        VALUE : '11',
        NAME : 'ESC-03'
    },
    ESC_02 :{
        VALUE : '10',
        NAME : 'ESC-02'
    },
    ESC_04 :{
        VALUE : '23',
        NAME : 'ESC-04'
    },
    EGC_01 :{
        VALUE : '19',
        NAME : 'EGC-01'
    },
    PEH_02 :{
        VALUE : '7',
        NAME : 'PEH-02'
    },
    PHD_01 :{
        VALUE : '13',
        NAME : 'PHD-01'
    },
    PHD_02 :{
        VALUE : '14',
        NAME : 'PHD-02'
    },
    PGC_01 :{
        VALUE : '8',
        NAME : 'PGC-01'
    },
    PFC_01 :{
        VALUE : '21',
        NAME : 'PFC-01'
    },
    PFC_02 :{
        VALUE : '32',
        NAME : 'PFC-02'
    },
    EDP_01 :{
        VALUE : '31',
        NAME : 'EDP-01'
    },
    EEG_02:{
        VALUE : '30',
        NAME : 'EEG-02' 
    },
    EEA_01a:{
        VALUE : '24',
        NAME : 'EEA-01a' 
    },
    EEA_01b:{
        VALUE : '25',
        NAME : 'EEA-01b' 
    },
    EEA_01c:{
        VALUE : '26',
        NAME : 'EEA-01c' 
    },
    EEA_01d:{
        VALUE : '27',
        NAME : 'EEA-01d' 
    },
    EEA_01e:{
        VALUE : '28',
        NAME : 'EEA-01e' 
    },
    ECS_01:{
        VALUE : '55',
        NAME : 'ECS-01' 
    },
    PGC_03a:{
        VALUE : '37',
        NAME : 'PGC-03a' 
    },
    PGC_03b:{
        VALUE : '38',
        NAME : 'PGC-03b' 
    },
    EIA_01:{
        VALUE : '46',
        NAME : 'EIA-01' 
    },
    EIA_03:{
        VALUE : '48',
        NAME : 'EIA_03' 
    },
    PFI_01:{
        VALUE : '64',
        NAME : 'PFI-01' 
    },
    PGC_04: {
        VALUE : '39',
        NAME : 'PGC-04'
    }
    
}); 


export const CONSTANTES = Object.freeze({
    WHATSAPP: "+51 931 133 333",
    WHATSAPP_URL: "51931133333",
    EMAIL: "informes@englishadvance.com.pe",
    PROGRAMA_INGLES_NIÑOS: 6,
    GROUP_MAX_STUDENTS: 10,
    COURSE_GENERAL_ENGLISH_URL: "https://englishadvance.com.pe/ingles-general",
    COURSE_BUSINESS_ENGLISH_URL: "https://englishadvance.com.pe/ingles-para-negocios",
    COURSE_KIDS_ENGLISH_URL: "https://englishadvance.com.pe/ingles-para-ninos",
    COURSE_INTERNATIONAL_EXAMS_URL: "https://englishadvance.com.pe/preparacion-para-examenes-internacionales",
    COURSE_CONVERSATION_CLASSES_URL: "https://englishadvance.com.pe/clases-de-conversacion",
    COURSE_GENERAL_ENGLISH_URL_EN: "https://englishadvance.com.pe/en/ingles-general",
    COURSE_BUSINESS_ENGLISH_URL_EN: "https://englishadvance.com.pe/en/ingles-para-negocios",
    COURSE_KIDS_ENGLISH_URL_EN: "https://englishadvance.com.pe/en/ingles-para-ninos",
    COURSE_INTERNATIONAL_EXAMS_URL_EN: "https://englishadvance.com.pe/en/preparacion-para-examenes-internacionales",
    COURSE_CONVERSATION_CLASSES_URL_EN: "https://englishadvance.com.pe/en/clases-de-conversacion",
}); 

export const STATUS_VALIDATION_COUNTER_PROPOSAL = Object.freeze({
    1: {
        ES: 'Profesor Respondio Propuesta',
        EN: 'Profesor Respondio Propuesta_Test'
    },
    2: {
        ES: 'Profesor Rechazo Propuesta',
        EN: 'Profesor Rechazo Propuesta_Test'
    },
    3: {
        ES: 'Encontraron Cambio Profesor',
        EN: 'Encontraron Cambio Profesor_test'
    },
    4: {
        ES: 'Estudiante Edito Propuesta',
        EN: 'Estudiante Edito Propuesta_Test'
    },
    5: {
        ES: 'Solicitud Cancelada',
        EN: 'Solicitud Cancelada_Test'
    },
    6: {
        ES: 'Solicitud Rechazada',
        EN: 'Solicitud Rechazada_Test'
    },
    7: {
        ES: 'Acepto otro horario',
        EN: 'Acepto otro horario_Test'
    },
    8: {
        ES: 'Sin Resultado',
        EN: 'Sin Resultado_Test'
    }
});

export const STATUS_CLASS = Object.freeze({
    PENDING  : {
        //4
        ES : 'Clase pendiente',
        EN : 'Pending class'
    },
    CANCELED_STUDENT  : {
        //3
        ES : 'Clase cancelada (estudiante)',
        ES_FORMAT : 'Class cancelada por ',
        EN : 'Class canceled (student)',
        EN_FORMAT : 'Class canceled by '
    },
    CANCELED_TEACER  : {
        //2
        ES : 'Clase cancelada (profesor)',
        EN : 'Class canceled (teacher)'
    },
    COMPLETED  : {
        //1
        ES : 'Clase completada',
        EN : 'Completed class'
    },
    COMPLETED_REPORT  : {
        //8
        ES : 'Clase completada (reporte pendiente)',
        EN : 'Completed class (pending report)'
    },
    CONFIRMED  : {
        //5
        ES : 'Clase por confirmar',
        EN : 'Class to be confirmed'
    },

    ABSENCE_TEACHER  : {
        //6
        ES : 'Profesor ausente',
        EN : 'Teacher absent'
    },
    FRONZE_CLASS  : {
        //9
        ES : 'Congelada',
        EN : 'Frozen'
    },
    ABSENCE_STUDENT  : {
        //7
        ES : 'Inasistencia del estudiante',
        EN : 'Student absent'
    },
    
    
}); 
 
export const STATUS_CLASS_CONSOLIDATED = Object.freeze({
    PENDING  : {
        //4
        ES : 'Clase pendiente',
        EN : 'Pending class'
    },
    CANCELED_STUDENT  : {
        //3
        ES : 'Cancelado a tiempo',
        ES_FORMAT : 'Cancelado a tiempo por ',
        EN : 'Cancelled on time',
        EN_FORMAT : 'Cancelled on time by '
    },
    COMPLETED  : {
        //1
        ES : 'Clase completada',
        EN : 'Completed class'
    },
    CONFIRMED  : {
        //5
        ES : 'Clase por confirmar',
        EN : 'Class to be confirmed'
    },
    ABSENCE_TEACHER  : {
        //6
        ES : 'Profesor ausente',
        EN : 'Teacher absent'
    },
    FRONZE_CLASS  : {
        //9
        ES : 'Congelada',
        EN : 'Frozen'
    },
    ABSENCE_STUDENT  : {
        //7
        ES : 'Cancelación tardía',
        EN : 'Late cancel'
    },
    
    
}); 

export const STATUS_REPORT_ENUM = Object.freeze({
    REPORT: {    
        ID : 1,
        NAME_EN : 'Completed' 
    } , 
    PENDING: {   
        ID : 2,
        NAME_EN : 'Pending' 
    } , 
}); 

export const CALENDAR_STATUS = Object.freeze({
    COMPLETED: {    //VERDE
        VALUE : '1',
        COLOR : '#00B14F' //008F39
    } , 
    CANCELED_TEACHER:{  //ROJO
        VALUE : '2',
        COLOR : '#D4263A'
    },
    CANCELED_STUDENT:{   //ROJO
        VALUE : '3',
        COLOR : '#D4263A'//'#6c757d' //GRIS
    },
    PENDIENT : {    //CELESTE
        VALUE : '4',
        COLOR : '#508ADF'
    },
    CONFIRM : {     //PENDIENTE
        VALUE : '5',
        COLOR : '#7986CC'
    },
    UNATTENDANCE_TEACHER : {    
        VALUE : '6',
        COLOR : '#D4263A'
    },
    UNATTENDANCE_STUDENT : {     
        VALUE : '7',
        COLOR : '#6c757d'
    },
    PENDING_REPORT : {     //REPORTE PENDIENTE
        VALUE : '8',
        COLOR : '#00B050'
    },
    FROZEN : {//Clase Congelada
        VALUE : '9',
        COLOR : '#000000'
    },
    UNAVAILABLE : {     //PENDIENTE
        VALUE : '10',
        COLOR : '#B2B2B2'
    }
}); 

export const CALENDAR_STATUS_CONSOLIDATED = Object.freeze({
    COMPLETED: {    //VERDE
        VALUE : '1',
        COLOR : '#00B14F' //008F39
    } , 
    CANCELED_STUDENT:{   //ROJO
        VALUE : '3',
        COLOR : '#6c757d'//'#6c757d' //GRIS
    },
    PENDIENT : {    //CELESTE
        VALUE : '4',
        COLOR : '#508ADF'
    },
    CONFIRM : {     //PENDIENTE
        VALUE : '5',
        COLOR : '#7986CC'
    },
    UNATTENDANCE_TEACHER : {    
        VALUE : '6',
        COLOR : '#6c757d'
    },
    UNATTENDANCE_STUDENT : {     
        VALUE : '7',
        COLOR : '#D4263A'
    },
    FROZEN : {//Clase Congelada
        VALUE : '9',
        COLOR : '#000000'
    },
    UNAVAILABLE : {     //PENDIENTE
        VALUE : '10',
        COLOR : '#B2B2B2'
    }
}); 

export const OPTION_STATUS = Object.freeze({
    VALUE0: {   
        VALUE : '0',
        EN : 'All' 
    } , 
    VALUE1:{
        VALUE : '1',
        EN : 'Not seen' 
    },
    VALUE2:{  
        VALUE : '2',
        EN : 'Seen' 
    },
    VALUE3 : {   
        VALUE : '3',
        EN : 'Accepted' 
    },
    VALUE4 : {     
        VALUE : '4',
        EN : 'Proposal sent' 
    },
    VALUE5 : {     
        VALUE : '5',
        EN : 'New conflicts' 
    }
}); 


export const TIPO_PLANES_IDS = Object.freeze({
    PLAN_INDIVIDUAL: 10,
	PLAN_DOS_PERSONAS: 11,
    PLAN_TRES_MAS_PERSONAS: 12 
}); 

export const PROGRAMS_IDS = Object.freeze({
    GENERAL_ENGLISH: 4,
	BUSINESS_ENGLISH: 5,
    KIDS_ENGLISH: 6, 
    CONVERSATION_CLASSES: 3
}); 

export const COURSE_STATUS = Object.freeze({
    VALUE1 :{
        NAME : 'Aprobado',
        NAME_EN : 'Passed',
        COLOR: "#8DBD65",
        ID : 1
    },
    VALUE2 :{
        NAME : 'Desaprobado',
        NAME_EN : 'Failed',
        COLOR: "#D4263A",
        ID : 2
    },
    VALUE3 :{
        NAME : 'Inconcluso',
        NAME_EN : 'Unfinished',
        COLOR: "#FDD51C",
        ID : 3
    },
    VALUE4 :{
        NAME : 'N/A',
        NAME_EN : 'N/A',
        COLOR: "#B7B8BD",
        ID : 4
    }
})

export const CERTFICATE = Object.freeze({
    VALUE1 :{
        NAME : 'Tiene',
        ID : 1
    },
    VALUE2 :{
        NAME : 'No tiene',
        ID : 2
    },
    VALUE3 :{
        NAME : 'N/A',
        ID : 3
    }
})


export const IMAGENES = Object.freeze({
    PHOTO_STUDENT_DEFAULT:  process.env.VUE_APP_S3_URL + "/usuarios/alumnos/avatar-default-student.png",
    PHOTO_TEACHER_DEFAULT: process.env.VUE_APP_S3_URL + "/usuarios/profesores/default-avatar.png",
    PHOTO_GROUP_DEFAULT: process.env.VUE_APP_S3_URL + "/usuarios/alumnos/group-icon.png"
});

export const PDF = Object.freeze({
    PDF_POLICY:  process.env.VUE_APP_S3_URL + "/admin/docs/Privacy+Policy.pdf",
    PDF_TERMS:  process.env.VUE_APP_S3_URL + "/admin/docs/Terms+of+Service.pdf",
    PDF_TEACHER_POLICY:  process.env.VUE_APP_S3_URL + "/admin/docs/Teacher's+Code+of+Conduct.pdf",
}); 

export const DEVICE = Object.freeze({
    PHONE:  320,
    TABLET:  768,
    DESKTOP:  1024,
}); 
export const TYPESTATEREPORTSTUDENT = Object.freeze({
    CREATEREPORT :0,
    VIEWREPORT :1,
})

export const IanaTimeZonesDos = [
    {value: 'Pacific/Niue', pos: '1', name: '(GMT-11:00) Niue Time'},
    {value: 'Pacific/Pago_Pago', pos: '2', name: '(GMT-11:00) Samoa Standard Time'},
    {value: 'Pacific/Rarotonga', pos: '3', name: '(GMT-10:00) Cook Islands Standard Time'},
    {value: 'Pacific/Honolulu', pos: '4', name: '(GMT-10:00) Hawaii-Aleutian Standard Time'},
    {value: 'Pacific/Tahiti', pos: '5', name: '(GMT-10:00) Tahiti Time'},
    {value: 'Pacific/Marquesas', pos: '6', name: '(GMT-09:30) Marquesas Time'},
    {value: 'Pacific/Gambier', pos: '7', name: '(GMT-09:00) Gambier Time'},
    {value: 'America/Adak', pos: '8', name: '(GMT-09:00) Hawaii-Aleutian Time (Adak)'},
    {value: 'America/Anchorage', pos: '9', name: '(GMT-08:00) Alaska Time - Anchorage'},
    {value: 'America/Juneau', pos: '10', name: '(GMT-08:00) Alaska Time - Juneau'},
    {value: 'America/Metlakatla', pos: '11', name: '(GMT-08:00) Alaska Time - Metlakatla'},
    {value: 'America/Nome', pos: '12', name: '(GMT-08:00) Alaska Time - Nome'},
    {value: 'America/Sitka', pos: '13', name: '(GMT-08:00) Alaska Time - Sitka'},
    {value: 'America/Yakutat', pos: '14', name: '(GMT-08:00) Alaska Time - Yakutat'},
    {value: 'Pacific/Pitcairn', pos: '15', name: '(GMT-08:00) Pitcairn Time'},
    {value: 'America/Hermosillo', pos: '16', name: '(GMT-07:00) Mexican Pacific Standard Time'},
    {value: 'America/Creston', pos: '17', name: '(GMT-07:00) Mountain Standard Time - Creston'},
    {value: 'America/Dawson', pos: '18', name: '(GMT-07:00) Mountain Standard Time - Dawson'},
    {value: 'America/Dawson_Creek', pos: '19', name: '(GMT-07:00) Mountain Standard Time - Dawson Creek'},
    {value: 'America/Fort_Nelson', pos: '20', name: '(GMT-07:00) Mountain Standard Time - Fort Nelson'},
    {value: 'America/Phoenix', pos: '21', name: '(GMT-07:00) Mountain Standard Time - Phoenix'},
    {value: 'America/Whitehorse', pos: '22', name: '(GMT-07:00) Mountain Standard Time - Whitehorse'},
    {value: 'America/Los_Angeles', pos: '23', name: '(GMT-07:00) Pacific Time - Los Angeles'},
    {value: 'America/Tijuana', pos: '24', name: '(GMT-07:00) Pacific Time - Tijuana'},
    {value: 'America/Vancouver', pos: '25', name: '(GMT-07:00) Pacific Time - Vancouver'},
    {value: 'America/Belize', pos: '26', name: '(GMT-06:00) Central Standard Time - Belize'},
    {value: 'America/Costa_Rica', pos: '27', name: '(GMT-06:00) Central Standard Time - Costa Rica'},
    {value: 'America/El_Salvador', pos: '28', name: '(GMT-06:00) Central Standard Time - El Salvador'},
    {value: 'America/Guatemala', pos: '29', name: '(GMT-06:00) Central Standard Time - Guatemala'},
    {value: 'America/Managua', pos: '30', name: '(GMT-06:00) Central Standard Time - Managua'},
    {value: 'America/Regina', pos: '31', name: '(GMT-06:00) Central Standard Time - Regina'},
    {value: 'America/Swift_Current', pos: '32', name: '(GMT-06:00) Central Standard Time - Swift Current'},
    {value: 'America/Tegucigalpa', pos: '33', name: '(GMT-06:00) Central Standard Time - Tegucigalpa'},
    {value: 'Pacific/Galapagos', pos: '34', name: '(GMT-06:00) Galapagos Time'},
    {value: 'America/Chihuahua', pos: '35', name: '(GMT-06:00) Mexican Pacific Time - Chihuahua'},
    {value: 'America/Mazatlan', pos: '36', name: '(GMT-06:00) Mexican Pacific Time - Mazatlan'},
    {value: 'America/Boise', pos: '37', name: '(GMT-06:00) Mountain Time - Boise'},
    {value: 'America/Cambridge_Bay', pos: '38', name: '(GMT-06:00) Mountain Time - Cambridge Bay'},
    {value: 'America/Denver', pos: '39', name: '(GMT-06:00) Mountain Time - Denver'},
    {value: 'America/Edmonton', pos: '40', name: '(GMT-06:00) Mountain Time - Edmonton'},
    {value: 'America/Inuvik', pos: '41', name: '(GMT-06:00) Mountain Time - Inuvik'},
    {value: 'America/Ojinaga', pos: '42', name: '(GMT-06:00) Mountain Time - Ojinaga'},
    {value: 'America/Yellowknife', pos: '43', name: '(GMT-06:00) Mountain Time - Yellowknife'},
    {value: 'America/Eirunepe', pos: '44', name: '(GMT-05:00) Acre Standard Time - Eirunepe'},
    {value: 'America/Rio_Branco', pos: '45', name: '(GMT-05:00) Acre Standard Time - Rio Branco'},
    {value: 'America/Bahia_Banderas', pos: '46', name: '(GMT-05:00) Central Time - Bahia Banderas'},
    {value: 'America/North_Dakota/Beulah', pos: '47', name: '(GMT-05:00) Central Time - Beulah, North Dakota'},
    {value: 'America/North_Dakota/Center', pos: '48', name: '(GMT-05:00) Central Time - Center, North Dakota'},
    {value: 'America/Chicago', pos: '49', name: '(GMT-05:00) Central Time - Chicago'},
    {value: 'America/Indiana/Knox', pos: '50', name: '(GMT-05:00) Central Time - Knox, Indiana'},
    {value: 'America/Matamoros', pos: '51', name: '(GMT-05:00) Central Time - Matamoros'},
    {value: 'America/Menominee', pos: '52', name: '(GMT-05:00) Central Time - Menominee'},
    {value: 'America/Merida', pos: '53', name: '(GMT-05:00) Central Time - Merida'},
    {value: 'America/Mexico_City', pos: '54', name: '(GMT-05:00) Central Time - Mexico City'},
    {value: 'America/Monterrey', pos: '55', name: '(GMT-05:00) Central Time - Monterrey'},
    {value: 'America/North_Dakota/New_Salem', pos: '56', name: '(GMT-05:00) Central Time - New Salem, North Dakota'},
    {value: 'America/Rainy_River', pos: '57', name: '(GMT-05:00) Central Time - Rainy River'},
    {value: 'America/Rankin_Inlet', pos: '58', name: '(GMT-05:00) Central Time - Rankin Inlet'},
    {value: 'America/Resolute', pos: '59', name: '(GMT-05:00) Central Time - Resolute'},
    {value: 'America/Indiana/Tell_City', pos: '60', name: '(GMT-05:00) Central Time - Tell City, Indiana'},
    {value: 'America/Winnipeg', pos: '61', name: '(GMT-05:00) Central Time - Winnipeg'},
    {value: 'America/Bogota', pos: '62', name: '(GMT-05:00) Colombia Standard Time'},
    {value: 'Pacific/Easter', pos: '63', name: '(GMT-05:00) Easter Island Time'},
    {value: 'America/Atikokan', pos: '64', name: '(GMT-05:00) Eastern Standard Time - Atikokan'},
    {value: 'America/Cancun', pos: '65', name: '(GMT-05:00) Eastern Standard Time - Cancun'},
    {value: 'America/Jamaica', pos: '66', name: '(GMT-05:00) Eastern Standard Time - Jamaica'},
    {value: 'America/Panama', pos: '67', name: '(GMT-05:00) Eastern Standard Time - Panama'},
    {value: 'America/Guayaquil', pos: '68', name: '(GMT-05:00) Ecuador Time'},
    {value: 'America/Lima', pos: '69', name: '(GMT-05:00) Peru Standard Time'},
    {value: 'America/Boa_Vista', pos: '70', name: '(GMT-04:00) Amazon Standard Time - Boa Vista'},
    {value: 'America/Campo_Grande', pos: '71', name: '(GMT-04:00) Amazon Standard Time - Campo Grande'},
    {value: 'America/Cuiaba', pos: '72', name: '(GMT-04:00) Amazon Standard Time - Cuiaba'},
    {value: 'America/Manaus', pos: '73', name: '(GMT-04:00) Amazon Standard Time - Manaus'},
    {value: 'America/Porto_Velho', pos: '74', name: '(GMT-04:00) Amazon Standard Time - Porto Velho'},
    {value: 'America/Barbados', pos: '75', name: '(GMT-04:00) Atlantic Standard Time - Barbados'},
    {value: 'America/Blanc-Sablon', pos: '76', name: '(GMT-04:00) Atlantic Standard Time - Blanc-Sablon'},
    {value: 'America/Curacao', pos: '77', name: '(GMT-04:00) Atlantic Standard Time - Curaçao'},
    {value: 'America/Martinique', pos: '78', name: '(GMT-04:00) Atlantic Standard Time - Martinique'},
    {value: 'America/Port_of_Spain', pos: '79', name: '(GMT-04:00) Atlantic Standard Time - Port of Spain'},
    {value: 'America/Puerto_Rico', pos: '80', name: '(GMT-04:00) Atlantic Standard Time - Puerto Rico'},
    {value: 'America/Santo_Domingo', pos: '81', name: '(GMT-04:00) Atlantic Standard Time - Santo Domingo'},
    {value: 'America/La_Paz', pos: '82', name: '(GMT-04:00) Bolivia Time'},
    {value: 'America/Havana', pos: '83', name: '(GMT-04:00) Cuba Time'},
    {value: 'America/Detroit', pos: '84', name: '(GMT-04:00) Eastern Time - Detroit'},
    {value: 'America/Grand_Turk', pos: '85', name: '(GMT-04:00) Eastern Time - Grand Turk'},
    {value: 'America/Indiana/Indianapolis', pos: '86', name: '(GMT-04:00) Eastern Time - Indianapolis'},
    {value: 'America/Iqaluit', pos: '87', name: '(GMT-04:00) Eastern Time - Iqaluit'},
    {value: 'America/Kentucky/Louisville', pos: '88', name: '(GMT-04:00) Eastern Time - Louisville'},
    {value: 'America/Indiana/Marengo', pos: '89', name: '(GMT-04:00) Eastern Time - Marengo, Indiana'},
    {value: 'America/Kentucky/Monticello', pos: '90', name: '(GMT-04:00) Eastern Time - Monticello, Kentucky'},
    {value: 'America/Nassau', pos: '91', name: '(GMT-04:00) Eastern Time - Nassau'},
    {value: 'America/New_York', pos: '92', name: '(GMT-04:00) Eastern Time - New York'},
    {value: 'America/Nipigon', pos: '93', name: '(GMT-04:00) Eastern Time - Nipigon'},
    {value: 'America/Pangnirtung', pos: '94', name: '(GMT-04:00) Eastern Time - Pangnirtung'},
    {value: 'America/Indiana/Petersburg', pos: '95', name: '(GMT-04:00) Eastern Time - Petersburg, Indiana'},
    {value: 'America/Port-au-Prince', pos: '96', name: '(GMT-04:00) Eastern Time - Port-au-Prince'},
    {value: 'America/Thunder_Bay', pos: '97', name: '(GMT-04:00) Eastern Time - Thunder Bay'},
    {value: 'America/Toronto', pos: '98', name: '(GMT-04:00) Eastern Time - Toronto'},
    {value: 'America/Indiana/Vevay', pos: '99', name: '(GMT-04:00) Eastern Time - Vevay, Indiana'},
    {value: 'America/Indiana/Vincennes', pos: '100', name: '(GMT-04:00) Eastern Time - Vincennes, Indiana'},
    {value: 'America/Indiana/Winamac', pos: '101', name: '(GMT-04:00) Eastern Time - Winamac, Indiana'},
    {value: 'America/Guyana', pos: '102', name: '(GMT-04:00) Guyana Time'},
    {value: 'America/Caracas', pos: '103', name: '(GMT-04:00) Venezuela Time'},
    {value: 'America/Argentina/Buenos_Aires', pos: '104', name: '(GMT-03:00) Argentina Standard Time - Buenos Aires'},
    {value: 'America/Argentina/Catamarca', pos: '105', name: '(GMT-03:00) Argentina Standard Time - Catamarca'},
    {value: 'America/Argentina/Cordoba', pos: '106', name: '(GMT-03:00) Argentina Standard Time - Cordoba'},
    {value: 'America/Argentina/Jujuy', pos: '107', name: '(GMT-03:00) Argentina Standard Time - Jujuy'},
    {value: 'America/Argentina/La_Rioja', pos: '108', name: '(GMT-03:00) Argentina Standard Time - La Rioja'},
    {value: 'America/Argentina/Mendoza', pos: '109', name: '(GMT-03:00) Argentina Standard Time - Mendoza'},
    {value: 'America/Argentina/Rio_Gallegos', pos: '110', name: '(GMT-03:00) Argentina Standard Time - Rio Gallegos'},
    {value: 'America/Argentina/Salta', pos: '111', name: '(GMT-03:00) Argentina Standard Time - Salta'},
    {value: 'America/Argentina/San_Juan', pos: '112', name: '(GMT-03:00) Argentina Standard Time - San Juan'},
    {value: 'America/Argentina/San_Luis', pos: '113', name: '(GMT-03:00) Argentina Standard Time - San Luis'},
    {value: 'America/Argentina/Tucuman', pos: '114', name: '(GMT-03:00) Argentina Standard Time - Tucuman'},
    {value: 'America/Argentina/Ushuaia', pos: '115', name: '(GMT-03:00) Argentina Standard Time - Ushuaia'},
    {value: 'Atlantic/Bermuda', pos: '116', name: '(GMT-03:00) Atlantic Time - Bermuda'},
    {value: 'America/Glace_Bay', pos: '117', name: '(GMT-03:00) Atlantic Time - Glace Bay'},
    {value: 'America/Goose_Bay', pos: '118', name: '(GMT-03:00) Atlantic Time - Goose Bay'},
    {value: 'America/Halifax', pos: '119', name: '(GMT-03:00) Atlantic Time - Halifax'},
    {value: 'America/Moncton', pos: '120', name: '(GMT-03:00) Atlantic Time - Moncton'},
    {value: 'America/Thule', pos: '121', name: '(GMT-03:00) Atlantic Time - Thule'},
    {value: 'America/Araguaina', pos: '122', name: '(GMT-03:00) Brasilia Standard Time - Araguaina'},
    {value: 'America/Bahia', pos: '123', name: '(GMT-03:00) Brasilia Standard Time - Bahia'},
    {value: 'America/Belem', pos: '124', name: '(GMT-03:00) Brasilia Standard Time - Belem'},
    {value: 'America/Fortaleza', pos: '125', name: '(GMT-03:00) Brasilia Standard Time - Fortaleza'},
    {value: 'America/Maceio', pos: '126', name: '(GMT-03:00) Brasilia Standard Time - Maceio'},
    {value: 'America/Recife', pos: '127', name: '(GMT-03:00) Brasilia Standard Time - Recife'},
    {value: 'America/Santarem', pos: '128', name: '(GMT-03:00) Brasilia Standard Time - Santarem'},
    {value: 'America/Sao_Paulo', pos: '129', name: '(GMT-03:00) Brasilia Standard Time - Sao Paulo'},
    {value: 'America/Santiago', pos: '130', name: '(GMT-03:00) Chile Time'},
    {value: 'Atlantic/Stanley', pos: '131', name: '(GMT-03:00) Falkland Islands Standard Time'},
    {value: 'America/Cayenne', pos: '132', name: '(GMT-03:00) French Guiana Time'},
    {value: 'Antarctica/Palmer', pos: '133', name: '(GMT-03:00) Palmer Time'},
    {value: 'America/Asuncion', pos: '134', name: '(GMT-03:00) Paraguay Time'},
    {value: 'America/Punta_Arenas', pos: '135', name: '(GMT-03:00) Punta Arenas Time'},
    {value: 'Antarctica/Rothera', pos: '136', name: '(GMT-03:00) Rothera Time'},
    {value: 'America/Paramaribo', pos: '137', name: '(GMT-03:00) Suriname Time'},
    {value: 'America/Montevideo', pos: '138', name: '(GMT-03:00) Uruguay Standard Time'},
    {value: 'America/St_Johns', pos: '139', name: '(GMT-02:30) Newfoundland Time'},
    {value: 'America/Noronha', pos: '140', name: '(GMT-02:00) Fernando de Noronha Standard Time'},
    {value: 'Atlantic/South_Georgia', pos: '141', name: '(GMT-02:00) South Georgia Time'},
    {value: 'America/Miquelon', pos: '142', name: '(GMT-02:00) St. Pierre & Miquelon Time'},
    {value: 'America/Nuuk', pos: '143', name: '(GMT-02:00) West Greenland Time'},
    {value: 'Atlantic/Cape_Verde', pos: '144', name: '(GMT-01:00) Cape Verde Standard Time'},
    {value: 'Atlantic/Azores', pos: '145', name: '(GMT+00:00) Azores Time'},
    {value: 'UTC', pos: '146', name: '(GMT+00:00) Coordinated Universal Time'},
    {value: 'America/Scoresbysund', pos: '147', name: '(GMT+00:00) East Greenland Time'},
    {value: 'Etc/GMT', pos: '148', name: '(GMT+00:00) Greenwich Mean Time'},
    {value: 'Africa/Abidjan', pos: '149', name: '(GMT+00:00) Greenwich Mean Time - Abidjan'},
    {value: 'Africa/Accra', pos: '150', name: '(GMT+00:00) Greenwich Mean Time - Accra'},
    {value: 'Africa/Bissau', pos: '151', name: '(GMT+00:00) Greenwich Mean Time - Bissau'},
    {value: 'America/Danmarkshavn', pos: '152', name: '(GMT+00:00) Greenwich Mean Time - Danmarkshavn'},
    {value: 'Africa/Monrovia', pos: '153', name: '(GMT+00:00) Greenwich Mean Time - Monrovia'},
    {value: 'Atlantic/Reykjavik', pos: '154', name: '(GMT+00:00) Greenwich Mean Time - Reykjavik'},
    {value: 'Africa/Sao_Tome', pos: '155', name: '(GMT+00:00) Greenwich Mean Time - São Tomé'},
    {value: 'Africa/Algiers', pos: '156', name: '(GMT+01:00) Central European Standard Time - Algiers'},
    {value: 'Africa/Tunis', pos: '157', name: '(GMT+01:00) Central European Standard Time - Tunis'},
    {value: 'Europe/Dublin', pos: '158', name: '(GMT+01:00) Ireland Time'},
    {value: 'Africa/Casablanca', pos: '159', name: '(GMT+01:00) Morocco Time'},
    {value: 'Europe/London', pos: '160', name: '(GMT+01:00) United Kingdom Time'},
    {value: 'Africa/Lagos', pos: '161', name: '(GMT+01:00) West Africa Standard Time - Lagos'},
    {value: 'Africa/Ndjamena', pos: '162', name: '(GMT+01:00) West Africa Standard Time - Ndjamena'},
    {value: 'Atlantic/Canary', pos: '163', name: '(GMT+01:00) Western European Time - Canary'},
    {value: 'Atlantic/Faroe', pos: '164', name: '(GMT+01:00) Western European Time - Faroe'},
    {value: 'Europe/Lisbon', pos: '165', name: '(GMT+01:00) Western European Time - Lisbon'},
    {value: 'Atlantic/Madeira', pos: '166', name: '(GMT+01:00) Western European Time - Madeira'},
    {value: 'Africa/El_Aaiun', pos: '167', name: '(GMT+01:00) Western Sahara Time'},
    {value: 'Africa/Juba', pos: '168', name: '(GMT+02:00) Central Africa Time - Juba'},
    {value: 'Africa/Khartoum', pos: '169', name: '(GMT+02:00) Central Africa Time - Khartoum'},
    {value: 'Africa/Maputo', pos: '170', name: '(GMT+02:00) Central Africa Time - Maputo'},
    {value: 'Africa/Windhoek', pos: '171', name: '(GMT+02:00) Central Africa Time - Windhoek'},
    {value: 'Europe/Amsterdam', pos: '172', name: '(GMT+02:00) Central European Time - Amsterdam'},
    {value: 'Europe/Andorra', pos: '173', name: '(GMT+02:00) Central European Time - Andorra'},
    {value: 'Europe/Belgrade', pos: '174', name: '(GMT+02:00) Central European Time - Belgrade'},
    {value: 'Europe/Berlin', pos: '175', name: '(GMT+02:00) Central European Time - Berlin'},
    {value: 'Europe/Brussels', pos: '176', name: '(GMT+02:00) Central European Time - Brussels'},
    {value: 'Europe/Budapest', pos: '177', name: '(GMT+02:00) Central European Time - Budapest'},
    {value: 'Africa/Ceuta', pos: '178', name: '(GMT+02:00) Central European Time - Ceuta'},
    {value: 'Europe/Copenhagen', pos: '179', name: '(GMT+02:00) Central European Time - Copenhagen'},
    {value: 'Europe/Gibraltar', pos: '180', name: '(GMT+02:00) Central European Time - Gibraltar'},
    {value: 'Europe/Luxembourg', pos: '181', name: '(GMT+02:00) Central European Time - Luxembourg'},
    {value: 'Europe/Madrid', pos: '182', name: '(GMT+02:00) Central European Time - Madrid'},
    {value: 'Europe/Malta', pos: '183', name: '(GMT+02:00) Central European Time - Malta'},
    {value: 'Europe/Monaco', pos: '184', name: '(GMT+02:00) Central European Time - Monaco'},
    {value: 'Europe/Oslo', pos: '185', name: '(GMT+02:00) Central European Time - Oslo'},
    {value: 'Europe/Paris', pos: '186', name: '(GMT+02:00) Central European Time - Paris'},
    {value: 'Europe/Prague', pos: '187', name: '(GMT+02:00) Central European Time - Prague'},
    {value: 'Europe/Rome', pos: '188', name: '(GMT+02:00) Central European Time - Rome'},
    {value: 'Europe/Stockholm', pos: '189', name: '(GMT+02:00) Central European Time - Stockholm'},
    {value: 'Europe/Tirane', pos: '190', name: '(GMT+02:00) Central European Time - Tirane'},
    {value: 'Europe/Vienna', pos: '191', name: '(GMT+02:00) Central European Time - Vienna'},
    {value: 'Europe/Warsaw', pos: '192', name: '(GMT+02:00) Central European Time - Warsaw'},
    {value: 'Europe/Zurich', pos: '193', name: '(GMT+02:00) Central European Time - Zurich'},
    {value: 'Africa/Cairo', pos: '194', name: '(GMT+02:00) Eastern European Standard Time - Cairo'},
    {value: 'Europe/Kaliningrad', pos: '195', name: '(GMT+02:00) Eastern European Standard Time - Kaliningrad'},
    {value: 'Africa/Tripoli', pos: '196', name: '(GMT+02:00) Eastern European Standard Time - Tripoli'},
    {value: 'Africa/Johannesburg', pos: '197', name: '(GMT+02:00) South Africa Standard Time'},
    {value: 'Antarctica/Troll', pos: '198', name: '(GMT+02:00) Troll Time'},
    {value: 'Asia/Baghdad', pos: '199', name: '(GMT+03:00) Arabian Standard Time - Baghdad'},
    {value: 'Asia/Qatar', pos: '200', name: '(GMT+03:00) Arabian Standard Time - Qatar'},
    {value: 'Asia/Riyadh', pos: '201', name: '(GMT+03:00) Arabian Standard Time - Riyadh'},
    {value: 'Africa/Nairobi', pos: '202', name: '(GMT+03:00) East Africa Time'},
    {value: 'Asia/Amman', pos: '203', name: '(GMT+03:00) Eastern European Time - Amman'},
    {value: 'Europe/Athens', pos: '204', name: '(GMT+03:00) Eastern European Time - Athens'},
    {value: 'Asia/Beirut', pos: '205', name: '(GMT+03:00) Eastern European Time - Beirut'},
    {value: 'Europe/Bucharest', pos: '206', name: '(GMT+03:00) Eastern European Time - Bucharest'},
    {value: 'Europe/Chisinau', pos: '207', name: '(GMT+03:00) Eastern European Time - Chisinau'},
    {value: 'Asia/Damascus', pos: '208', name: '(GMT+03:00) Eastern European Time - Damascus'},
    {value: 'Asia/Gaza', pos: '209', name: '(GMT+03:00) Eastern European Time - Gaza'},
    {value: 'Asia/Hebron', pos: '210', name: '(GMT+03:00) Eastern European Time - Hebron'},
    {value: 'Europe/Helsinki', pos: '211', name: '(GMT+03:00) Eastern European Time - Helsinki'},
    {value: 'Europe/Kiev', pos: '212', name: '(GMT+03:00) Eastern European Time - Kiev'},
    {value: 'Asia/Nicosia', pos: '213', name: '(GMT+03:00) Eastern European Time - Nicosia'},
    {value: 'Europe/Riga', pos: '214', name: '(GMT+03:00) Eastern European Time - Riga'},
    {value: 'Europe/Sofia', pos: '215', name: '(GMT+03:00) Eastern European Time - Sofia'},
    {value: 'Europe/Tallinn', pos: '216', name: '(GMT+03:00) Eastern European Time - Tallinn'},
    {value: 'Europe/Uzhgorod', pos: '217', name: '(GMT+03:00) Eastern European Time - Uzhhorod'},
    {value: 'Europe/Vilnius', pos: '218', name: '(GMT+03:00) Eastern European Time - Vilnius'},
    {value: 'Europe/Zaporozhye', pos: '219', name: '(GMT+03:00) Eastern European Time - Zaporozhye'},
    {value: 'Asia/Famagusta', pos: '220', name: '(GMT+03:00) Famagusta Time'},
    {value: 'Asia/Jerusalem', pos: '221', name: '(GMT+03:00) Israel Time'},
    {value: 'Europe/Kirov', pos: '222', name: '(GMT+03:00) Kirov Time'},
    {value: 'Europe/Minsk', pos: '223', name: '(GMT+03:00) Moscow Standard Time - Minsk'},
    {value: 'Europe/Moscow', pos: '224', name: '(GMT+03:00) Moscow Standard Time - Moscow'},
    {value: 'Europe/Simferopol', pos: '225', name: '(GMT+03:00) Moscow Standard Time - Simferopol'},
    {value: 'Antarctica/Syowa', pos: '226', name: '(GMT+03:00) Syowa Time'},
    {value: 'Europe/Istanbul', pos: '227', name: '(GMT+03:00) Turkey Time'},
    {value: 'Europe/Volgograd', pos: '228', name: '(GMT+03:00) Volgograd Standard Time'},
    {value: 'Asia/Tehran', pos: '229', name: '(GMT+03:30) Iran Time'},
    {value: 'Asia/Yerevan', pos: '230', name: '(GMT+04:00) Armenia Standard Time'},
    {value: 'Europe/Astrakhan', pos: '231', name: '(GMT+04:00) Astrakhan Time'},
    {value: 'Asia/Baku', pos: '232', name: '(GMT+04:00) Azerbaijan Standard Time'},
    {value: 'Asia/Tbilisi', pos: '233', name: '(GMT+04:00) Georgia Standard Time'},
    {value: 'Asia/Dubai', pos: '234', name: '(GMT+04:00) Gulf Standard Time'},
    {value: 'Indian/Mauritius', pos: '235', name: '(GMT+04:00) Mauritius Standard Time'},
    {value: 'Indian/Reunion', pos: '236', name: '(GMT+04:00) Réunion Time'},
    {value: 'Europe/Samara', pos: '237', name: '(GMT+04:00) Samara Standard Time'},
    {value: 'Europe/Saratov', pos: '238', name: '(GMT+04:00) Saratov Time'},
    {value: 'Indian/Mahe', pos: '239', name: '(GMT+04:00) Seychelles Time'},
    {value: 'Europe/Ulyanovsk', pos: '240', name: '(GMT+04:00) Ulyanovsk Time'},
    {value: 'Asia/Kabul', pos: '241', name: '(GMT+04:30) Afghanistan Time'},
    {value: 'Indian/Kerguelen', pos: '242', name: '(GMT+05:00) French Southern & Antarctic Time'},
    {value: 'Indian/Maldives', pos: '243', name: '(GMT+05:00) Maldives Time'},
    {value: 'Antarctica/Mawson', pos: '244', name: '(GMT+05:00) Mawson Time'},
    {value: 'Asia/Karachi', pos: '245', name: '(GMT+05:00) Pakistan Standard Time'},
    {value: 'Asia/Dushanbe', pos: '246', name: '(GMT+05:00) Tajikistan Time'},
    {value: 'Asia/Ashgabat', pos: '247', name: '(GMT+05:00) Turkmenistan Standard Time'},
    {value: 'Asia/Samarkand', pos: '248', name: '(GMT+05:00) Uzbekistan Standard Time - Samarkand'},
    {value: 'Asia/Tashkent', pos: '249', name: '(GMT+05:00) Uzbekistan Standard Time - Tashkent'},
    {value: 'Asia/Aqtau', pos: '250', name: '(GMT+05:00) West Kazakhstan Time - Aqtau'},
    {value: 'Asia/Aqtobe', pos: '251', name: '(GMT+05:00) West Kazakhstan Time - Aqtobe'},
    {value: 'Asia/Atyrau', pos: '252', name: '(GMT+05:00) West Kazakhstan Time - Atyrau'},
    {value: 'Asia/Oral', pos: '253', name: '(GMT+05:00) West Kazakhstan Time - Oral'},
    {value: 'Asia/Qyzylorda', pos: '254', name: '(GMT+05:00) West Kazakhstan Time - Qyzylorda'},
    {value: 'Asia/Yekaterinburg', pos: '255', name: '(GMT+05:00) Yekaterinburg Standard Time'},
    {value: 'Asia/Colombo', pos: '256', name: '(GMT+05:30) India Standard Time - Colombo'},
    {value: 'Asia/Kolkata', pos: '257', name: '(GMT+05:30) India Standard Time - Kolkata'},
    {value: 'Asia/Kathmandu', pos: '258', name: '(GMT+05:45) Nepal Time'},
    {value: 'Asia/Dhaka', pos: '259', name: '(GMT+06:00) Bangladesh Standard Time'},
    {value: 'Asia/Thimphu', pos: '260', name: '(GMT+06:00) Bhutan Time'},
    {value: 'Asia/Almaty', pos: '261', name: '(GMT+06:00) East Kazakhstan Time - Almaty'},
    {value: 'Asia/Qostanay', pos: '262', name: '(GMT+06:00) East Kazakhstan Time - Kostanay'},
    {value: 'Indian/Chagos', pos: '263', name: '(GMT+06:00) Indian Ocean Time'},
    {value: 'Asia/Bishkek', pos: '264', name: '(GMT+06:00) Kyrgyzstan Time'},
    {value: 'Asia/Omsk', pos: '265', name: '(GMT+06:00) Omsk Standard Time'},
    {value: 'Asia/Urumqi', pos: '266', name: '(GMT+06:00) Urumqi Time'},
    {value: 'Antarctica/Vostok', pos: '267', name: '(GMT+06:00) Vostok Time'},
    {value: 'Indian/Cocos', pos: '268', name: '(GMT+06:30) Cocos Islands Time'},
    {value: 'Asia/Yangon', pos: '269', name: '(GMT+06:30) Myanmar Time'},
    {value: 'Asia/Barnaul', pos: '270', name: '(GMT+07:00) Barnaul Time'},
    {value: 'Indian/Christmas', pos: '271', name: '(GMT+07:00) Christmas Island Time'},
    {value: 'Antarctica/Davis', pos: '272', name: '(GMT+07:00) Davis Time'},
    {value: 'Asia/Hovd', pos: '273', name: '(GMT+07:00) Hovd Standard Time'},
    {value: 'Asia/Bangkok', pos: '274', name: '(GMT+07:00) Indochina Time - Bangkok'},
    {value: 'Asia/Ho_Chi_Minh', pos: '275', name: '(GMT+07:00) Indochina Time - Ho Chi Minh City'},
    {value: 'Asia/Krasnoyarsk', pos: '276', name: '(GMT+07:00) Krasnoyarsk Standard Time - Krasnoyarsk'},
    {value: 'Asia/Novokuznetsk', pos: '277', name: '(GMT+07:00) Krasnoyarsk Standard Time - Novokuznetsk'},
    {value: 'Asia/Novosibirsk', pos: '278', name: '(GMT+07:00) Novosibirsk Standard Time'},
    {value: 'Asia/Tomsk', pos: '279', name: '(GMT+07:00) Tomsk Time'},
    {value: 'Asia/Jakarta', pos: '280', name: '(GMT+07:00) Western Indonesia Time - Jakarta'},
    {value: 'Asia/Pontianak', pos: '281', name: '(GMT+07:00) Western Indonesia Time - Pontianak'},
    {value: 'Australia/Perth', pos: '282', name: '(GMT+08:00) Australian Western Standard Time'},
    {value: 'Asia/Brunei', pos: '283', name: '(GMT+08:00) Brunei Darussalam Time'},
    {value: 'Asia/Makassar', pos: '284', name: '(GMT+08:00) Central Indonesia Time'},
    {value: 'Asia/Macau', pos: '285', name: '(GMT+08:00) China Standard Time - Macao'},
    {value: 'Asia/Shanghai', pos: '286', name: '(GMT+08:00) China Standard Time - Shanghai'},
    {value: 'Asia/Hong_Kong', pos: '287', name: '(GMT+08:00) Hong Kong Standard Time'},
    {value: 'Asia/Irkutsk', pos: '288', name: '(GMT+08:00) Irkutsk Standard Time'},
    {value: 'Asia/Kuala_Lumpur', pos: '289', name: '(GMT+08:00) Malaysia Time - Kuala Lumpur'},
    {value: 'Asia/Kuching', pos: '290', name: '(GMT+08:00) Malaysia Time - Kuching'},
    {value: 'Asia/Manila', pos: '291', name: '(GMT+08:00) Philippine Standard Time'},
    {value: 'Asia/Singapore', pos: '292', name: '(GMT+08:00) Singapore Standard Time'},
    {value: 'Asia/Taipei', pos: '293', name: '(GMT+08:00) Taipei Standard Time'},
    {value: 'Asia/Choibalsan', pos: '294', name: '(GMT+08:00) Ulaanbaatar Standard Time - Choibalsan'},
    {value: 'Asia/Ulaanbaatar', pos: '295', name: '(GMT+08:00) Ulaanbaatar Standard Time - Ulaanbaatar'},
    {value: 'Australia/Eucla', pos: '296', name: '(GMT+08:45) Australian Central Western Standard Time'},
    {value: 'Asia/Dili', pos: '297', name: '(GMT+09:00) East Timor Time'},
    {value: 'Asia/Jayapura', pos: '298', name: '(GMT+09:00) Eastern Indonesia Time'},
    {value: 'Asia/Tokyo', pos: '299', name: '(GMT+09:00) Japan Standard Time'},
    {value: 'Asia/Pyongyang', pos: '300', name: '(GMT+09:00) Korean Standard Time - Pyongyang'},
    {value: 'Asia/Seoul', pos: '301', name: '(GMT+09:00) Korean Standard Time - Seoul'},
    {value: 'Pacific/Palau', pos: '302', name: '(GMT+09:00) Palau Time'},
    {value: 'Asia/Chita', pos: '303', name: '(GMT+09:00) Yakutsk Standard Time - Chita'},
    {value: 'Asia/Khandyga', pos: '304', name: '(GMT+09:00) Yakutsk Standard Time - Khandyga'},
    {value: 'Asia/Yakutsk', pos: '305', name: '(GMT+09:00) Yakutsk Standard Time - Yakutsk'},
    {value: 'Australia/Darwin', pos: '306', name: '(GMT+09:30) Australian Central Standard Time'},
    {value: 'Australia/Brisbane', pos: '307', name: '(GMT+10:00) Australian Eastern Standard Time - Brisbane'},
    {value: 'Australia/Lindeman', pos: '308', name: '(GMT+10:00) Australian Eastern Standard Time - Lindeman'},
    {value: 'Pacific/Guam', pos: '309', name: '(GMT+10:00) Chamorro Standard Time'},
    {value: 'Pacific/Chuuk', pos: '310', name: '(GMT+10:00) Chuuk Time'},
    {value: 'Antarctica/DumontDUrville', pos: '311', name: '(GMT+10:00) Dumont-d’Urville Time'},
    {value: 'Pacific/Port_Moresby', pos: '312', name: '(GMT+10:00) Papua New Guinea Time'},
    {value: 'Asia/Ust-Nera', pos: '313', name: '(GMT+10:00) Vladivostok Standard Time - Ust-Nera'},
    {value: 'Asia/Vladivostok', pos: '314', name: '(GMT+10:00) Vladivostok Standard Time - Vladivostok'},
    {value: 'Australia/Adelaide', pos: '315', name: '(GMT+10:30) Central Australia Time - Adelaide'},
    {value: 'Australia/Broken_Hill', pos: '316', name: '(GMT+10:30) Central Australia Time - Broken Hill'},
    {value: 'Pacific/Bougainville', pos: '317', name: '(GMT+11:00) Bougainville Time'},
    {value: 'Antarctica/Casey', pos: '318', name: '(GMT+11:00) Casey Time'},
    {value: 'Australia/Hobart', pos: '319', name: '(GMT+11:00) Eastern Australia Time - Hobart'},
    {value: 'Antarctica/Macquarie', pos: '320', name: '(GMT+11:00) Eastern Australia Time - Macquarie'},
    {value: 'Australia/Melbourne', pos: '321', name: '(GMT+11:00) Eastern Australia Time - Melbourne'},
    {value: 'Australia/Sydney', pos: '322', name: '(GMT+11:00) Eastern Australia Time - Sydney'},
    {value: 'Pacific/Kosrae', pos: '323', name: '(GMT+11:00) Kosrae Time'},
    {value: 'Australia/Lord_Howe', pos: '324', name: '(GMT+11:00) Lord Howe Time'},
    {value: 'Asia/Magadan', pos: '325', name: '(GMT+11:00) Magadan Standard Time'},
    {value: 'Pacific/Noumea', pos: '326', name: '(GMT+11:00) New Caledonia Standard Time'},
    {value: 'Pacific/Pohnpei', pos: '327', name: '(GMT+11:00) Ponape Time'},
    {value: 'Asia/Sakhalin', pos: '328', name: '(GMT+11:00) Sakhalin Standard Time'},
    {value: 'Pacific/Guadalcanal', pos: '329', name: '(GMT+11:00) Solomon Islands Time'},
    {value: 'Asia/Srednekolymsk', pos: '330', name: '(GMT+11:00) Srednekolymsk Time'},
    {value: 'Pacific/Efate', pos: '331', name: '(GMT+11:00) Vanuatu Standard Time'},
    {value: 'Asia/Anadyr', pos: '332', name: '(GMT+12:00) Anadyr Standard Time'},
    {value: 'Pacific/Fiji', pos: '333', name: '(GMT+12:00) Fiji Time'},
    {value: 'Pacific/Tarawa', pos: '334', name: '(GMT+12:00) Gilbert Islands Time'},
    {value: 'Pacific/Kwajalein', pos: '335', name: '(GMT+12:00) Marshall Islands Time - Kwajalein'},
    {value: 'Pacific/Majuro', pos: '336', name: '(GMT+12:00) Marshall Islands Time - Majuro'},
    {value: 'Pacific/Nauru', pos: '337', name: '(GMT+12:00) Nauru Time'},
    {value: 'Pacific/Norfolk', pos: '338', name: '(GMT+12:00) Norfolk Island Time'},
    {value: 'Asia/Kamchatka', pos: '339', name: '(GMT+12:00) Petropavlovsk-Kamchatski Standard Time'},
    {value: 'Pacific/Funafuti', pos: '340', name: '(GMT+12:00) Tuvalu Time'},
    {value: 'Pacific/Wake', pos: '341', name: '(GMT+12:00) Wake Island Time'},
    {value: 'Pacific/Wallis', pos: '342', name: '(GMT+12:00) Wallis & Futuna Time'},
    {value: 'Pacific/Auckland', pos: '343', name: '(GMT+13:00) New Zealand Time'},
    {value: 'Pacific/Enderbury', pos: '344', name: '(GMT+13:00) Phoenix Islands Time'},
    {value: 'Pacific/Fakaofo', pos: '345', name: '(GMT+13:00) Tokelau Time'},
    {value: 'Pacific/Tongatapu', pos: '346', name: '(GMT+13:00) Tonga Standard Time'},
    {value: 'Pacific/Chatham', pos: '347', name: '(GMT+13:45) Chatham Time'},
    {value: 'Pacific/Apia', pos: '348', name: '(GMT+13:00) Apia Standard Time'},
    {value: 'Pacific/Kiritimati', pos: '349', name: '(GMT+14:00) Line Islands Time'}
];



export const IanaTimeZones = [
    'Europe/Andorra',
    'Asia/Dubai',
    'Asia/Kabul',
    'Europe/Tirane',
    'Asia/Yerevan',
    'Antarctica/Casey',
    'Antarctica/Davis',
    'Antarctica/DumontDUrville', // https://bugs.chromium.org/p/chromium/issues/detail?id=928068
    'Antarctica/Mawson',
    'Antarctica/Palmer',
    'Antarctica/Rothera',
    'Antarctica/Syowa',
    'Antarctica/Troll',
    'Antarctica/Vostok',
    'America/Argentina/Buenos_Aires',
    'America/Argentina/Cordoba',
    'America/Argentina/Salta',
    'America/Argentina/Jujuy',
    'America/Argentina/Tucuman',
    'America/Argentina/Catamarca',
    'America/Argentina/La_Rioja',
    'America/Argentina/San_Juan',
    'America/Argentina/Mendoza',
    'America/Argentina/San_Luis',
    'America/Argentina/Rio_Gallegos',
    'America/Argentina/Ushuaia',
    'Pacific/Pago_Pago',
    'Europe/Vienna',
    'Australia/Lord_Howe',
    'Antarctica/Macquarie',
    'Australia/Hobart',
    'Australia/Currie',
    'Australia/Melbourne',
    'Australia/Sydney',
    'Australia/Broken_Hill',
    'Australia/Brisbane',
    'Australia/Lindeman',
    'Australia/Adelaide',
    'Australia/Darwin',
    'Australia/Perth',
    'Australia/Eucla',
    'Asia/Baku',
    'America/Barbados',
    'Asia/Dhaka',
    'Europe/Brussels',
    'Europe/Sofia',
    'Atlantic/Bermuda',
    'Asia/Brunei',
    'America/La_Paz',
    'America/Noronha',
    'America/Belem',
    'America/Fortaleza',
    'America/Recife',
    'America/Araguaina',
    'America/Maceio',
    'America/Bahia',
    'America/Sao_Paulo',
    'America/Campo_Grande',
    'America/Cuiaba',
    'America/Santarem',
    'America/Porto_Velho',
    'America/Boa_Vista',
    'America/Manaus',
    'America/Eirunepe',
    'America/Rio_Branco',
    'America/Nassau',
    'Asia/Thimphu',
    'Europe/Minsk',
    'America/Belize',
    'America/St_Johns',
    'America/Halifax',
    'America/Glace_Bay',
    'America/Moncton',
    'America/Goose_Bay',
    'America/Blanc-Sablon',
    'America/Toronto',
    'America/Nipigon',
    'America/Thunder_Bay',
    'America/Iqaluit',
    'America/Pangnirtung',
    'America/Atikokan',
    'America/Winnipeg',
    'America/Rainy_River',
    'America/Resolute',
    'America/Rankin_Inlet',
    'America/Regina',
    'America/Swift_Current',
    'America/Edmonton',
    'America/Cambridge_Bay',
    'America/Yellowknife',
    'America/Inuvik',
    'America/Creston',
    'America/Dawson_Creek',
    'America/Fort_Nelson',
    'America/Vancouver',
    'America/Whitehorse',
    'America/Dawson',
    'Indian/Cocos',
    'Europe/Zurich',
    'Africa/Abidjan',
    'Pacific/Rarotonga',
    'America/Santiago',
    'America/Punta_Arenas',
    'Pacific/Easter',
    'Asia/Shanghai',
    'Asia/Urumqi',
    'America/Bogota',
    'America/Costa_Rica',
    'America/Havana',
    'Atlantic/Cape_Verde',
    'America/Curacao',
    'Indian/Christmas',
    'Asia/Nicosia',
    'Asia/Famagusta',
    'Europe/Prague',
    'Europe/Berlin',
    'Europe/Copenhagen',
    'America/Santo_Domingo',
    'Africa/Algiers',
    'America/Guayaquil',
    'Pacific/Galapagos',
    'Europe/Tallinn',
    'Africa/Cairo',
    'Africa/El_Aaiun',
    'Europe/Madrid',
    'Africa/Ceuta',
    'Atlantic/Canary',
    'Europe/Helsinki',
    'Pacific/Fiji',
    'Atlantic/Stanley',
    'Pacific/Chuuk',
    'Pacific/Pohnpei',
    'Pacific/Kosrae',
    'Atlantic/Faroe',
    'Europe/Paris',
    'Europe/London',
    'Asia/Tbilisi',
    'America/Cayenne',
    'Africa/Accra',
    'Europe/Gibraltar',
    'America/Godthab',
    'America/Danmarkshavn',
    'America/Scoresbysund',
    'America/Thule',
    'Europe/Athens',
    'Atlantic/South_Georgia',
    'America/Guatemala',
    'Pacific/Guam',
    'Africa/Bissau',
    'America/Guyana',
    'Asia/Hong_Kong',
    'America/Tegucigalpa',
    'America/Port-au-Prince',
    'Europe/Budapest',
    'Asia/Jakarta',
    'Asia/Pontianak',
    'Asia/Makassar',
    'Asia/Jayapura',
    'Europe/Dublin',
    'Asia/Jerusalem',
    'Asia/Kolkata',
    'Indian/Chagos',
    'Asia/Baghdad',
    'Asia/Tehran',
    'Atlantic/Reykjavik',
    'Europe/Rome',
    'America/Jamaica',
    'Asia/Amman',
    'Asia/Tokyo',
    'Africa/Nairobi',
    'Asia/Bishkek',
    'Pacific/Tarawa',
    'Pacific/Enderbury',
    'Pacific/Kiritimati',
    'Asia/Pyongyang',
    'Asia/Seoul',
    'Asia/Almaty',
    'Asia/Qyzylorda',
    'Asia/Qostanay', // https://bugs.chromium.org/p/chromium/issues/detail?id=928068
    'Asia/Aqtobe',
    'Asia/Aqtau',
    'Asia/Atyrau',
    'Asia/Oral',
    'Asia/Beirut',
    'Asia/Colombo',
    'Africa/Monrovia',
    'Europe/Vilnius',
    'Europe/Luxembourg',
    'Europe/Riga',
    'Africa/Tripoli',
    'Africa/Casablanca',
    'Europe/Monaco',
    'Europe/Chisinau',
    'Pacific/Majuro',
    'Pacific/Kwajalein',
    'Asia/Yangon',
    'Asia/Ulaanbaatar',
    'Asia/Hovd',
    'Asia/Choibalsan',
    'Asia/Macau',
    'America/Martinique',
    'Europe/Malta',
    'Indian/Mauritius',
    'Indian/Maldives',
    'America/Mexico_City',
    'America/Cancun',
    'America/Merida',
    'America/Monterrey',
    'America/Matamoros',
    'America/Mazatlan',
    'America/Chihuahua',
    'America/Ojinaga',
    'America/Hermosillo',
    'America/Tijuana',
    'America/Bahia_Banderas',
    'Asia/Kuala_Lumpur',
    'Asia/Kuching',
    'Africa/Maputo',
    'Africa/Windhoek',
    'Pacific/Noumea',
    'Pacific/Norfolk',
    'Africa/Lagos',
    'America/Managua',
    'Europe/Amsterdam',
    'Europe/Oslo',
    'Asia/Kathmandu',
    'Pacific/Nauru',
    'Pacific/Niue',
    'Pacific/Auckland',
    'Pacific/Chatham',
    'America/Panama',
    'America/Lima',
    'Pacific/Tahiti',
    'Pacific/Marquesas',
    'Pacific/Gambier',
    'Pacific/Port_Moresby',
    'Pacific/Bougainville',
    'Asia/Manila',
    'Asia/Karachi',
    'Europe/Warsaw',
    'America/Miquelon',
    'Pacific/Pitcairn',
    'America/Puerto_Rico',
    'Asia/Gaza',
    'Asia/Hebron',
    'Europe/Lisbon',
    'Atlantic/Madeira',
    'Atlantic/Azores',
    'Pacific/Palau',
    'America/Asuncion',
    'Asia/Qatar',
    'Indian/Reunion',
    'Europe/Bucharest',
    'Europe/Belgrade',
    'Europe/Kaliningrad',
    'Europe/Moscow',
    'Europe/Simferopol',
    'Europe/Kirov',
    'Europe/Astrakhan',
    'Europe/Volgograd',
    'Europe/Saratov',
    'Europe/Ulyanovsk',
    'Europe/Samara',
    'Asia/Yekaterinburg',
    'Asia/Omsk',
    'Asia/Novosibirsk',
    'Asia/Barnaul',
    'Asia/Tomsk',
    'Asia/Novokuznetsk',
    'Asia/Krasnoyarsk',
    'Asia/Irkutsk',
    'Asia/Chita',
    'Asia/Yakutsk',
    'Asia/Khandyga',
    'Asia/Vladivostok',
    'Asia/Ust-Nera',
    'Asia/Magadan',
    'Asia/Sakhalin',
    'Asia/Srednekolymsk',
    'Asia/Kamchatka',
    'Asia/Anadyr',
    'Asia/Riyadh',
    'Pacific/Guadalcanal',
    'Indian/Mahe',
    'Africa/Khartoum',
    'Europe/Stockholm',
    'Asia/Singapore',
    'America/Paramaribo',
    'Africa/Juba',
    'Africa/Sao_Tome',
    'America/El_Salvador',
    'Asia/Damascus',
    'America/Grand_Turk',
    'Africa/Ndjamena',
    'Indian/Kerguelen',
    'Asia/Bangkok',
    'Asia/Dushanbe',
    'Pacific/Fakaofo',
    'Asia/Dili',
    'Asia/Ashgabat',
    'Africa/Tunis',
    'Pacific/Tongatapu',
    'Europe/Istanbul',
    'America/Port_of_Spain',
    'Pacific/Funafuti',
    'Asia/Taipei',
    'Europe/Kiev',
    'Europe/Uzhgorod',
    'Europe/Zaporozhye',
    'Pacific/Wake',
    'America/New_York',
    'America/Detroit',
    'America/Kentucky/Louisville',
    'America/Kentucky/Monticello',
    'America/Indiana/Indianapolis',
    'America/Indiana/Vincennes',
    'America/Indiana/Winamac',
    'America/Indiana/Marengo',
    'America/Indiana/Petersburg',
    'America/Indiana/Vevay',
    'America/Chicago',
    'America/Indiana/Tell_City',
    'America/Indiana/Knox',
    'America/Menominee',
    'America/North_Dakota/Center',
    'America/North_Dakota/New_Salem',
    'America/North_Dakota/Beulah',
    'America/Denver',
    'America/Boise',
    'America/Phoenix',
    'America/Los_Angeles',
    'America/Anchorage',
    'America/Juneau',
    'America/Sitka',
    'America/Metlakatla',
    'America/Yakutat',
    'America/Nome',
    'America/Adak',
    'Pacific/Honolulu',
    'America/Montevideo',
    'Asia/Samarkand',
    'Asia/Tashkent',
    'America/Caracas',
    'Asia/Ho_Chi_Minh',
    'Pacific/Efate',
    'Pacific/Wallis',
    'Pacific/Apia',
    'Africa/Johannesburg'
  ];

export const SUPPORTEDFILES_HE = [
    '.docx',
    '.doc',
    '.pdf',
    '.png',
    '.jpg',
    '.jpeg',
    '.ppt', 
    '.pptx', 
    '.xls', 
    '.xlsx'
];
    


export const PARAMETROS = Object.freeze({
    TEACHER_METHODOLOGY_MIN_WORDS: 40,
    MAX_TAMANIO_ARCHIVO: 50
});

export const CALENDAR_STATUS_ADDITIONAL_COLOR = Object.freeze({
    NORECURRENT :'#5A6BA3',
})